var _rect, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1035px",
    height: "540px",
    viewBox: "0 0 1035 540",
    enableBackground: "new 0 0 1035 540",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    width: 1035,
    height: 540
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FF9869",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    cx: 331.2,
    cy: 147.9,
    rx: 12.7,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    cx: 323.8,
    cy: 134.2,
    rx: 15,
    ry: 14.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A0DAE8",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M179.3,285.6c0,0-12.9,55.6-15.6,65.2 c-2.7,9.6-7.8,31.1,10.5,37.8c0,0,16.9,7,24.5-25.4c7.6-32.3,14.9-69.9,14.9-69.9S192.4,285.9,179.3,285.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0DAE8",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M326.4,285.6c0,0,12.9,55.6,15.6,65.2 c2.7,9.6,7.8,31.1-10.5,37.8c0,0-16.9,7-24.5-25.4c-7.6-32.3-14.9-69.9-14.9-69.9S313.2,285.9,326.4,285.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A0DAE8",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M314,290.3c0,0,0.4,41.4,2.2,47.6 s2.9,41.8-9,64.5s-2.5,29.8-28.8,30.7s-18.2-18.9-19.8-20.7H247c-1.6,1.8,6.5,21.6-19.8,20.7s-16.9-8-28.8-30.7 c-11.9-22.7-10.8-58.3-9-64.5s2.2-47.6,2.2-47.6H314z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 252.8,
    cy: 351.6,
    rx: 34.9,
    ry: 29.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 243.4,
    y1: 412.5,
    x2: 262.3,
    y2: 412.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M223.8,295.1c0,0,12.3,52.1,9.2,100c-0.2,2.3-2.1,4.1-4.4,4.1h-42.2c-2.7,0-4.7-2.3-4.4-5l3.5-28.6 l-30.7-14.6c-2.1-1-3.1-3.4-2.2-5.6c5.1-13.2,22-56.5,26.7-60.6C184.9,280.2,218.1,286.8,223.8,295.1z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible",
    fill: "#FF9869"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173154335109650570460000004825170616229360269_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000173154335109650570460000004825170616229360269_)",
    fill: "#FFFFFF",
    d: "M215.5,289.3 c0,0,9.4,63.8,8.6,98.4c0,0.9-0.8,1.7-1.7,1.7h-41.9l-2.1,14.2h60.2c0,0,4.6-80.4-8.5-111.5S215.5,289.3,215.5,289.3z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000173154335109650570460000004825170616229360269_)",
    fill: "#FFFFFF",
    d: "M154.6,340.1l32.1,15.2 c0,0-0.7,23.4-8.4,25.5s-49.2-28.2-49.2-28.2S130.6,335,154.6,340.1z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible",
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 185.5,
    y1: 365.7,
    x2: 191.1,
    y2: 318.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000000937502900938737940000013676177607985594549_",
    d: "M281.9,295.1c0,0-12.3,52.1-9.2,100 c0.2,2.3,2.1,4.1,4.4,4.1h42.2c2.7,0,4.7-2.3,4.4-5l-3.5-28.6l30.7-14.6c2.1-1,3.1-3.4,2.2-5.6c-5.1-13.2-22-56.5-26.7-60.6 C320.8,280.2,287.5,286.8,281.9,295.1z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000937502900938737940000013676177607985594549_",
    overflow: "visible",
    fill: "#FF9869"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150784047186789167700000013091724344472466861_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000937502900938737940000013676177607985594549_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000150784047186789167700000013091724344472466861_)",
    fill: "#FFFFFF",
    d: "M290.2,289.3 c0,0-9.4,63.8-8.6,98.4c0,0.9,0.8,1.7,1.7,1.7h41.9l2.1,14.2h-60.2c0,0-4.6-80.4,8.5-111.5S290.2,289.3,290.2,289.3z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000150784047186789167700000013091724344472466861_)",
    fill: "#FFFFFF",
    d: "M351,340.1l-32.1,15.2 c0,0,0.7,23.4,8.4,25.5s49.2-28.2,49.2-28.2S375.1,335,351,340.1z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000937502900938737940000013676177607985594549_",
    overflow: "visible",
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 320.2,
    y1: 365.7,
    x2: 314.5,
    y2: 318.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8613 -0.508 0.508 0.8613 -38.4768 112.9214)",
    fill: "#FFFFFF",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    cx: 187.6,
    cy: 126.9,
    rx: 14.3,
    ry: 17.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8613 -0.508 0.508 0.8613 -38.2122 112.6493)",
    fill: "#291D1B",
    cx: 187.3,
    cy: 126.3,
    rx: 3,
    ry: 5.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.508 -0.8613 0.8613 0.508 43.8254 330.6261)",
    fill: "#FFFFFF",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    cx: 311.3,
    cy: 126.9,
    rx: 17.1,
    ry: 14.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.508 -0.8613 0.8613 0.508 44.5402 330.636)",
    fill: "#291D1B",
    cx: 311.7,
    cy: 126.3,
    rx: 5.8,
    ry: 3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000101071562898867659650000010569603063014787496_",
    d: "M351.2,230.7c-2.7-8.7-4.4-32.1-4.4-32.1 c-2.9-76.9-71.7-85.5-93.9-86.3l0,0c0,0-1.2-0.1-3.4-0.1c-2.2,0-3.4,0.1-3.4,0.1l0,0c-22.1,0.8-91,9.4-93.9,86.3 c0,0-1.8,23.4-4.4,32.1c-2.6,8.5-30.5,65.9,98.8,67.6l0,0c1,0,1.9,0,2.9,0c1,0,1.9,0,2.9,0l0,0 C381.7,296.6,353.8,239.2,351.2,230.7z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101071562898867659650000010569603063014787496_",
    overflow: "visible",
    fill: "#A0DAE8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104703810064618656410000000576190110919582639_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101071562898867659650000010569603063014787496_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("ellipse", {
    clipPath: "url(#SVGID_00000104703810064618656410000000576190110919582639_)",
    fill: "#FFFFFF",
    cx: 249.5,
    cy: 303.7,
    rx: 135.9,
    ry: 91.8
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101071562898867659650000010569603063014787496_",
    overflow: "visible",
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000011032830807908018300000012343454234089801626_",
    d: "M200.2,122.8c0,0,48.5,5.5,98.6,0 c0,0,17.9,6.5,30.7,23.8c0,0-62.3,14.7-160,0C169.5,146.6,181.3,130.3,200.2,122.8z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011032830807908018300000012343454234089801626_",
    overflow: "visible",
    fill: "#FF986C"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006687917147063041210000018053912052783056820_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011032830807908018300000012343454234089801626_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polyline", {
    clipPath: "url(#SVGID_00000006687917147063041210000018053912052783056820_)",
    fill: "#FFFFFF",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    points: " 223.5,121 197.8,155 229.7,155 252.2,121 279.2,121 259.5,159.3 289.8,159.3 307.8,120.1  "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011032830807908018300000012343454234089801626_",
    overflow: "visible",
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M276.9,179 c0,0,1.6-5.6,7.6-4.6c6,1,4.9,6.6,4.9,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M222,179 c0,0-1.6-5.6-7.6-4.6s-4.9,6.6-4.9,6.6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#291D1B",
    cx: 280.1,
    cy: 200.9,
    rx: 5.8,
    ry: 6.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#291D1B",
    cx: 218.9,
    cy: 200.9,
    rx: 5.8,
    ry: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#291F22",
    d: "M245.7,216.7h7.5c1,0,2,0.5,2.5,1.4l1.7,2.7c0.7,1.1,0.5,2.6-0.4,3.5l-5,5.4c-1.1,1.2-3,1.3-4.2,0.1 l-5.7-5.5c-1-1-1.2-2.5-0.5-3.7l1.6-2.6C243.7,217.2,244.7,216.7,245.7,216.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 249.5,
    y1: 227.4,
    x2: 249.5,
    y2: 238.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M235.2,238.9 c0,0,8.8,7.3,14.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M263.8,238.9 c0,0-8.8,7.3-14.3,0"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FF9CA6",
    cx: 184.6,
    cy: 230.7,
    rx: 10.7,
    ry: 8.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FF9CA6",
    cx: 314.3,
    cy: 230.7,
    rx: 10.7,
    ry: 8.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 205.2,
    y1: 225.1,
    x2: 187.2,
    y2: 222.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 205.2,
    y1: 233,
    x2: 186.7,
    y2: 234.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 293.8,
    y1: 225.1,
    x2: 311.8,
    y2: 222.3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 293.8,
    y1: 233,
    x2: 312.3,
    y2: 234.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A0DAE8",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M860.2,285.6c0,0,12.9,55.6,15.6,65.2 c2.7,9.6,7.8,31.1-10.5,37.8c0,0-16.9,7-24.5-25.4c-7.6-32.3-14.9-69.9-14.9-69.9S847,285.9,860.2,285.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0DAE8",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M713.1,285.6c0,0-12.9,55.6-15.6,65.2 c-2.7,9.6-7.8,31.1,10.5,37.8c0,0,16.9,7,24.5-25.4c7.6-32.3,14.9-69.9,14.9-69.9S726.2,285.9,713.1,285.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A0DAE8",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M725.4,290.3c0,0-0.4,41.4-2.2,47.6 s-2.9,41.8,9,64.5c11.9,22.7,2.5,29.8,28.8,30.7c26.3,0.9,18.2-18.9,19.8-20.7h11.6c1.6,1.8-6.5,21.6,19.8,20.7s16.9-8,28.8-30.7 c11.9-22.7,10.8-58.3,9-64.5s-2.2-47.6-2.2-47.6H725.4z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 796,
    y1: 412.5,
    x2: 777.2,
    y2: 412.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000069380958141834695530000012805458532849853596_",
    d: "M862.7,284.1l26.3,56.6c0,0,4,6.6-3.6,9.7 c-7.6,3.1-31.1,14.2-31.1,14.2l3.1,26.3c0,0,2.3,8.7-5.8,9.8c-50.3,6.7-129.9,0-129.9,0c-8-1.3-5.8-9.8-5.8-9.8l3.1-26.3 c0,0-23.6-11.1-31.1-14.2c-7.6-3.1-3.6-9.7-3.6-9.7l26.3-56.6C710.6,284.1,805.2,264.5,862.7,284.1z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069380958141834695530000012805458532849853596_",
    overflow: "visible",
    fill: "#FF9869"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134219567195986176430000007504863512653417866_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069380958141834695530000012805458532849853596_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000134219567195986176430000007504863512653417866_)",
    fill: "#FFFFFF",
    d: "M856.9,388l-4.2-34.4 c8-2.2,41.7-18.3,41.7-18.3s35.9,42.7,33.7,43.6s-40.5,59.4-59.9,60.1c-19.4,0.7-143-5.6-142.9-5.6c0.1,0-38.2-6.9-38.2-11.6 c0-4.7-8.7-51.8-8.7-51.8s-21.1-16,2-33.2c0,0,35.2,16.3,40.2,17.4l-4.5,33.8C716.2,388,811.7,397.1,856.9,388z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069380958141834695530000012805458532849853596_",
    overflow: "visible",
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 725.4,
    y1: 313.5,
    x2: 718.8,
    y2: 366.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 847.7,
    y1: 313.5,
    x2: 854.3,
    y2: 366.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.508 -0.8613 0.8613 0.508 308.0905 793.2932)",
    fill: "#FFFFFF",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    cx: 848.5,
    cy: 126.9,
    rx: 17.1,
    ry: 14.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.508 -0.8613 0.8613 0.508 308.8054 793.3032)",
    fill: "#291D1B",
    cx: 848.8,
    cy: 126.3,
    rx: 5.8,
    ry: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8613 -0.508 0.508 0.8613 36.0003 385.8005)",
    fill: "#FFFFFF",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    cx: 724.8,
    cy: 126.9,
    rx: 14.3,
    ry: 17.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8613 -0.508 0.508 0.8613 36.2649 385.5284)",
    fill: "#291D1B",
    cx: 724.4,
    cy: 126.3,
    rx: 3,
    ry: 5.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000072966900795329628190000004974992802413539713_",
    d: "M684.9,230.7c2.7-8.7,4.4-32.1,4.4-32.1 c2.9-76.9,71.7-85.5,93.9-86.3l0,0c0,0,1.2-0.1,3.4-0.1c2.2,0,3.4,0.1,3.4,0.1v0c22.1,0.8,91,9.4,93.9,86.3 c0,0,1.8,23.4,4.4,32.1c2.6,8.5,30.5,65.9-98.8,67.6l0,0c-1,0-1.9,0-2.9,0c-1,0-1.9,0-2.9,0l0,0 C654.4,296.6,682.3,239.2,684.9,230.7z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072966900795329628190000004974992802413539713_",
    overflow: "visible",
    fill: "#A0DAE8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094586255774812013280000008161674889729918887_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072966900795329628190000004974992802413539713_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072966900795329628190000004974992802413539713_",
    overflow: "visible",
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000078746603628985933870000012965160580618940337_",
    d: "M835.9,122.8c0,0-48.5,5.5-98.6,0 c0,0-17.9,6.5-30.7,23.8c0,0,62.3,14.7,160,0C866.6,146.6,854.8,130.3,835.9,122.8z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078746603628985933870000012965160580618940337_",
    overflow: "visible",
    fill: "#FF986C"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072978940546291051700000000585283262288504243_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078746603628985933870000012965160580618940337_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polyline", {
    clipPath: "url(#SVGID_00000072978940546291051700000000585283262288504243_)",
    fill: "#FFFFFF",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    points: " 812.6,121 838.3,155 806.4,155 783.9,121 756.9,121 776.6,159.3 746.4,159.3 728.3,120.1  "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078746603628985933870000012965160580618940337_",
    overflow: "visible",
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF9869",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    cx: 703,
    cy: 147.7,
    r: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    cx: 712.2,
    cy: 134.2,
    rx: 15,
    ry: 14.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000132782492762899286490000008270783295370486713_",
    d: "M471.9,278.9c0,0-5.5,36.3-12.2,51 c-6.7,14.7-24.5,70.1,34,82.1c0,0,1.6,22,17.9,21.6c17.9-0.5,25.7,2.7,30.7-10.7c5-13.3,9-11.8,23.7-19.8 c14.7-8,16-17.6,7.6-58.1c-8.5-40.5-9.8-69-9.8-69L471.9,278.9z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132782492762899286490000008270783295370486713_",
    overflow: "visible",
    fill: "#A0DAE8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044870667228620709690000002905711959431072650_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132782492762899286490000008270783295370486713_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("ellipse", {
    clipPath: "url(#SVGID_00000044870667228620709690000002905711959431072650_)",
    fill: "#FFFFFF",
    cx: 465.1,
    cy: 350.6,
    rx: 34.9,
    ry: 29.7
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132782492762899286490000008270783295370486713_",
    overflow: "visible",
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000107551205370479571900000010722044787017338772_",
    d: "M481.7,280.8c0,0-4.2,58.1-4.5,73.9s-6.2,39.5,5.6,43.6 c11.8,4.2,114.6,12.8,116.4-6.5s-11.3-93.2-25.8-114.5C558.8,255.8,481.7,280.8,481.7,280.8z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107551205370479571900000010722044787017338772_",
    overflow: "visible",
    fill: "#FF9869"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005250287177979759920000008866204855420139432_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107551205370479571900000010722044787017338772_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000005250287177979759920000008866204855420139432_)",
    fill: "#FFFFFF",
    d: "M489.2,265.6 c0,0-1.3,92.9-3.8,117c-0.3,2.6,1.6,4.9,4.2,5.2c18.1,1.7,81.6,6.8,111.9-4.4c35.6-13.1,1.5,31.4,0,31.7 c-1.5,0.3-136.1,5.6-138.2,4.4c-2.1-1.2-26.5-17.8-24.4-29.4s11.9-87.5,13.1-88.4S478.6,252,489.2,265.6z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107551205370479571900000010722044787017338772_",
    overflow: "visible",
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A0DAE8",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M537.5,327.3c0,0-0.6,19.3-0.3,29.2 c0.3,9.9,0.2,32.1-19.1,34.3c0,0-18.1,2.9-17.8-30.4c0.3-33.1,2-33.6,2-33.6S524.6,324.4,537.5,327.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000103956588124870604840000006321002213353982626_",
    d: "M491.8,316.4c0,0-5.6,36.8-5,40.3s1.2,6.8,27.3,7.1 c26.1,0.3,35-0.9,34.7-11.3c-0.3-10.4-1.2-35-1.2-35"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103956588124870604840000006321002213353982626_",
    overflow: "visible",
    fill: "#FF9869"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002358627207334695030000009558271134197354897_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103956588124870604840000006321002213353982626_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000002358627207334695030000009558271134197354897_)",
    fill: "#FFFFFF",
    d: "M480.5,352.3 c0.9,0.3,55.8,4.4,79.2-3.6c23.4-8,13.3,15.2,4.2,15.2c-9.2,0-92.3,8-92.3,8L480.5,352.3z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103956588124870604840000006321002213353982626_",
    overflow: "visible",
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000181801848543364572730000008022175049013492883_",
    d: "M529.5,112.4c0,0-62.7-3.2-86.6,42.2 c-20.2,38.3-10.4,64.4-12.1,66.6c-9.9,12.5-28.7,77.5,98.8,77.5c105.6,0,86.3-69.2,83.7-87.3 C610.5,193.3,616.7,115.8,529.5,112.4z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181801848543364572730000008022175049013492883_",
    overflow: "visible",
    fill: "#A0DAE8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088098958131328410800000016705504834803777966_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181801848543364572730000008022175049013492883_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_00000088098958131328410800000016705504834803777966_)",
    fill: "#FFFFFF",
    d: "M611.6,294.5 c0,49.3-75.6,96.6-168.9,96.6s-168.9-40-168.9-89.3s-93.8-89.3,168.9-89.3C515,212.5,611.6,245.1,611.6,294.5z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181801848543364572730000008022175049013492883_",
    overflow: "visible",
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#291D1B",
    d: "M428,216.9h3.8c2.4,0,4.4,1.4,5,3.5l0.7,2.6c0.5,1.7-0.2,3.6-1.7,4.7l-3.1,2.3c-2.1,1.6-5.2,1.4-7-0.5 l-2.5-2.5c-1.4-1.4-1.7-3.3-0.9-5l1.2-2.4C424.1,218,425.9,216.9,428,216.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M424,240.2 c0,0,6,4.3,13.6-0.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    cx: 527.1,
    cy: 122.4,
    rx: 15.4,
    ry: 18.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#291D1B",
    cx: 526.8,
    cy: 121.2,
    rx: 2.9,
    ry: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000095302669912068244070000017612558031209146260_",
    d: "M478.8,122.3c0,0,47.1,8.9,97.2,3.1 c0,0,16.1,9.7,24.8,28.2c0,0-90.6,8-152.4-4.9c-0.7-0.2-1.1-1-0.6-1.6C451.2,142.6,463.3,127.6,478.8,122.3z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095302669912068244070000017612558031209146260_",
    overflow: "visible",
    fill: "#FF986C"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103227066347950140440000015658204919462938241_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095302669912068244070000017612558031209146260_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polyline", {
    clipPath: "url(#SVGID_00000103227066347950140440000015658204919462938241_)",
    fill: "#FFFFFF",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    points: " 497.7,122.1 470.8,161.5 502.8,161.5 526.4,122.1 553.4,122.1 533.8,160.4 564,160.4 582.1,121.2  "
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000095302669912068244070000017612558031209146260_",
    overflow: "visible",
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M462.6,179.3 c0,0,1.6-5.6,7.6-4.6s4.9,6.6,4.9,6.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#291D1B",
    cx: 465.7,
    cy: 201.2,
    rx: 5.8,
    ry: 6.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FF9CA6",
    cx: 499.1,
    cy: 231.2,
    rx: 10.7,
    ry: 8.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 478.5,
    y1: 225.6,
    x2: 496.5,
    y2: 222.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 478.5,
    y1: 233.4,
    x2: 497,
    y2: 234.7
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF9869",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    cx: 529.4,
    cy: 143.2,
    r: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    stroke: "#291D1B",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    cx: 528.7,
    cy: 129.5,
    rx: 15,
    ry: 14.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC5);
export default __webpack_public_path__ + "static/media/c5.7c360539b35b8e965e9e7e954cf3a45a.svg";
export { ForwardRef as ReactComponent };